export const SETDONORINFO = "SETDONORINFO"

export const setDonorInfo = (donorInfo) => ({
  type: SETDONORINFO,
  donorInfo
})

